<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_12"></a><a id="part001"></a><strong>Part I<br/>Ten Ways to idea-Condition Your Mind</strong></h2>
<p class="image"><a id="page_13"></a><img alt="Image" src="images/f0013-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?11239470